// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { Overrides } from "@material-ui/core/styles/overrides";

export default {
  /**
   * Put your Material Ui overrides here.
   * For example:
   *
   *  MuiFormLabel: {
   *    root: {
   *      color: "red",
   *    },
   *  },
   */
} as Overrides;
